// extracted by mini-css-extract-plugin
module.exports = {"goalBadge":"GoalBadge_goalBadge__FM5L5","pulse":"GoalBadge_pulse__1RVF2"};